import { Identity, IsString } from "@pdfking/tfunc"
import { object_map } from "@pdfking/rfunc"
import get_filedata from "./get_filedata"

const shorten = (path: string): string => {
  const { basename, ext } = get_filedata(path)
  return ext ? `${basename}.${ext}` : basename
}

function get_short_name(path: string): string
function get_short_name<T>(paths: Record<string, T>): Record<string, T>
function get_short_name<T>(
  input: string | Record<string, T>
): string | Record<string, T> {
  if (IsString(input)) return shorten(input)
  return object_map((_v, k) => shorten(k), Identity, input)
}

export default get_short_name
